import { gql } from '@apollo/client';

import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';
import { SubjectFragment } from 'approot/shared/graphql/startup-data/startup-data.graphql';

export const stimulusVideoFragment = gql`
  fragment StimulusVideo on StimulusResourceVideoData {
    link
    source
    embed
  }
`;

export const stimulusResourceFragment = gql`
  fragment StimulusResource on StimulusResource {
    ... on StimulusResourceInterface {
      id
      name
      description
      type
      slug
      sort
      yearsAttached
      contentTypes
      subjects {
        ...SubjectFragment
      }
      lessons {
        name
        slug
        subjects {
          ...SubjectFragment
        }
        years {
          id
          name
        }
        squareImage {
          ...ResponsiveImageFragment
        }
        unit {
          id
          name
        }
        archivedAt
      }
      assessments {
        name
        slug
        subjects {
          ...SubjectFragment
        }
        years {
          id
          name
        }
        squareImage {
          ...ResponsiveImageFragment
        }
        unit {
          id
          name
        }
        archivedAt
      }
      coverImage {
        ...ResponsiveImageFragment
      }
      xlCoverImage {
        ...ResponsiveImageFragment
      }
      xlCoverImageUrls {
        width
        height
        urls {
          url
          quality
        }
      }
    }
    ... on StimulusResourceLink {
      link
    }
    ... on StimulusResourceVideo {
      durationMinutes
      videos {
        ...StimulusVideo
      }
      attributions {
        author
        copyright
        licence
        modifications
        modificationDescription
        contentWarning
      }
    }
    ... on StimulusResourceAudio {
      durationMinutes
      videos {
        ...StimulusVideo
      }
      attributions {
        author
        copyright
        licence
        modifications
        modificationDescription
        contentWarning
      }
    }
    ... on StimulusResourceDocument {
      link
      totalPages
      documentKey
      documentId
      fileName
    }
    ... on StimulusResourceInteractive {
      link
    }
    ... on StimulusResourceGuidedResearch {
      links {
        title
        description
        link
      }
    }
    ... on StimulusResourceWebTool {
      link
    }
    ... on StimulusResourceImage {
      image {
        ...ResponsiveImageFragment
        imageType
        classification
      }
      link
      altText
    }
    ... on StimulusResourceEBook {
      link
      totalPages
      documentKey
      documentId
      fileName
    }
    ... on StimulusResourceEBookInteractive {
      link
    }
  }
  ${ResponsiveImageFragment}
  ${stimulusVideoFragment}
  ${SubjectFragment}
`;

export const REORDER_STIMULUS_RESOURCE = gql`
  mutation ReorderStimulusResource($input: ReorderStimulusResourceInput!) {
    reorderStimulusResource(input: $input) {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const DETACH_STIMULUS_RESOURCE = gql`
  mutation DetachStimulusResource($input: DetachStimulusResourceInput!) {
    detachStimulusResource(input: $input) {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const GET_STIMULUS_RESOURCE = gql`
  query GetStimulusResource($input: GetStimulusResourceInput!) {
    getStimulusResource(input: $input) {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const SEARCH_STIMULUS_RESOURCES = gql`
  query SearchStimulusResources($input: SearchStimulusResourcesInput!) {
    searchStimulusResources(input: $input) {
      total
      pageSize
      currentPage
      stimulusResources {
        ...StimulusResource
      }
    }
  }
  ${stimulusResourceFragment}
`;
